import styled from 'styled-components';
import { Select } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(Select) `
  &&& {
    ${theme.typography.bodyLG};
    border-color: ${theme.colors.borderDark};
    border-radius: ${theme.spacing.xs};
    color: ${theme.colors.textTertiary};
    height: 42px;

    &:hover {
      color: ${theme.colors.text};

      .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.colors.borderBrand};
      }
    }

    &.Mui-focused {
      color: ${theme.colors.text};
      outline: 4px solid #eae8f2;

      .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.colors.borderBrand};
        border-width: 1px;
      }
    }

    //selected state
    &:not(:has(.MuiSelect-nativeInput[value=''])) {
      background: ${theme.colors.backgroundBrandLight};
      color: ${theme.colors.text};

      .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.colors.buttonOutlinedTextDefault};
        padding-inline: ${theme.spacing.md};
      }
    }

    .MuiInputBase-input {
      padding: ${theme.spacing.xs}
        calc(${theme.spacing.md} * 2 + ${theme.icons.md}) ${theme.spacing.xs}
        ${theme.spacing.md};
      position: relative;
      z-index: 1;
    }

    svg {
      position: absolute;
      right: ${theme.spacing.md};
    }

    legend span {
      visibility: hidden;
    }
  }
`;
